import React, { useState } from "react";

import {
  AppBar,
  Box,
  Container,
  Divider,
  Drawer,
  IconButton,
  List,
  ListItemButton,
  ListItemText,
  Toolbar,
  Typography,
} from "@mui/material";
import { Menu } from "@mui/icons-material";

import Logo from "./Logo";

const NavBar = () => {
  // State to manage whether the drawer is open or closed
  const [open, setOpen] = useState(false);

  // Toggle the drawer open/close
  const toggleDrawer = () => {
    setOpen(!open);
  };

  return (
    <AppBar
      position="static"
      sx={{
        position: "sticky",
        top: 0,
        width: "100%",
        zIndex: 2,
      }}
    >
      <Container maxWidth="xl">
        <Toolbar disableGutters>
          <IconButton
            edge="start"
            color="inherit"
            onClick={toggleDrawer}
            aria-label="menu"
          >
            <Menu />
          </IconButton>
          {/* Drawer Component */}
          <Drawer anchor="left" open={open} onClose={toggleDrawer}>
            <div
              role="presentation"
              onClick={toggleDrawer}
              onKeyDown={toggleDrawer}
              style={{ width: 250 }}
            >
              <List>
                <ListItemButton>
                  <ListItemText primary="Transfers" />
                </ListItemButton>
                <ListItemButton>
                  <ListItemText primary="Retail Supplies" />
                </ListItemButton>
                <ListItemButton>
                  <ListItemText primary="Inbound Shipments" />
                </ListItemButton>
                <ListItemButton>
                  <ListItemText primary="Outbound Shipments" />
                </ListItemButton>
                <Divider />
                <ListItemButton>
                  <ListItemText primary="Knowledge Base" />
                </ListItemButton>
                <Divider />
                <ListItemButton>
                  <ListItemText primary="Calendar" />
                </ListItemButton>
                <ListItemButton>
                  <ListItemText primary="Bulletin" />
                </ListItemButton>
                <Divider />
                <ListItemButton>
                  <ListItemText primary="Order Lookup" />
                </ListItemButton>
                <ListItemButton>
                  <ListItemText primary="Store Reporting" />
                </ListItemButton>
                <ListItemButton>
                  <ListItemText primary="Retail Standards" />
                </ListItemButton>
                <Divider />
              </List>
            </div>
          </Drawer>
          <Logo paddingRight={"2vh"} color={"white"} />
          <Typography
            variant="h6"
            noWrap
            component="a"
            href="/"
            sx={{
              mr: 2,
              display: { xs: "none", md: "flex" },
              fontWeight: 700,
              color: "inherit",
              textDecoration: "none",
            }}
          >
            Lighthouse
          </Typography>
          <Box sx={{ flexGrow: 1, display: { xs: "none", md: "flex" } }}>
            {" "}
            <Typography
              variant="h2"
              noWrap
              sx={{
                flexGrow: 1,
                fontSize: 16,
                color: "inherit",
                textDecoration: "none",
                textAlign: "center",
              }}
            >
              ANNOUNCEMENT ALERTS
            </Typography>
          </Box>
          <Box sx={{ flexGrow: 0 }}>
            <Typography
              variant="h2"
              noWrap
              sx={{
                display: { xs: "none", md: "flex" },
                fontSize: 16,
                color: "inherit",
                textDecoration: "none",
              }}
            >
              Submit a Ticket
            </Typography>
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
};

export default NavBar;
